import React, {useState} from "react";
import {useTheme} from "../../../../../connectui/theme/ThemeProvider";
import {buildStyles} from "../../../../../connectui/component/buildStyles";
import Container from "../../../../../connectui/component/layout/Container";
import DropdownExpand from "../../../../../connectui/component/display/dropdown/DropdownExpand";
import FlexContainer from "../../../../../connectui/component/layout/FlexContainer";
import Text from "../../../../../connectui/component/display/Text";
import SvgIcon from "../../../../../connectui/component/display/SvgIcon";
import ICONS from "../../../../../connectui/icons/iconMap";
import BookingCustomFields from "../../../../../components/Panels/Booking/BookingCustomFields";
import {
  editBooking,
  updateBooking,
} from "../../../../../redux/actions/bookingsActions";
import {useDispatch} from "react-redux";

const useStyles = (theme) =>
  buildStyles({
    cardContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      padding: theme.spacing(2, 3, 0),
      borderBottom: `1px solid ${theme.colors.border}`,
    },
  });

const CustomFieldsCard = ({booking}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const totalFields = booking?.custom ? Object.keys(booking.custom).length : 0;

  const handleCustomFieldUpdate = (id, customField) => {
    const body = {
      guest_id: booking.guest_id,
      booking_id: booking.booking_id,
      custom: customField,
    };
    dispatch(
      editBooking({
        ...booking,
        custom: {...booking.custom, [id]: customField[id]},
      }),
    );
    dispatch(updateBooking(body));
  };

  if (booking && !totalFields) {
    return null;
  }
  return (
    <Container className={classes.cardContainer}>
      <DropdownExpand
        customLabel={
          <FlexContainer
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{width: "100%"}}
          >
            <FlexContainer alignItems={"center"} gap={theme.spacing(1)}>
              <SvgIcon
                component={ICONS["list"]}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: theme.colors.textPrimary,
                }}
              />
              <Text variant="textSM" weight="medium">
                {"Booking Fields"}
              </Text>
              <Text
                variant="textXS"
                weight="medium"
                color="textSecondary"
                sx={{marginLeft: theme.spacing(1)}}
              >
                {`${totalFields} Fields`}
              </Text>
            </FlexContainer>
          </FlexContainer>
        }
        divider={false}
        expanded={expanded === true}
        onExpand={() => setExpanded(!expanded)}
      >
        <BookingCustomFields
          booking={booking}
          newExpanded={true}
          onCustomFieldSave={handleCustomFieldUpdate}
        />
      </DropdownExpand>
    </Container>
  );
};
export default CustomFieldsCard;
